/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Gopay_Return_SyncingInputs */

const cs_billing_gopay_return_syncing = /** @type {(inputs: Billing_Gopay_Return_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potvrzuji platbu…`)
};

const en_billing_gopay_return_syncing = /** @type {(inputs: Billing_Gopay_Return_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirming payment…`)
};

/**
* | output |
* | --- |
* | "Confirming payment…" |
*
* @param {Billing_Gopay_Return_SyncingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_gopay_return_syncing = /** @type {((inputs?: Billing_Gopay_Return_SyncingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Gopay_Return_SyncingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_gopay_return_syncing(inputs)
	return cs_billing_gopay_return_syncing(inputs)
});